import React, { useState } from 'react';
import parse from 'html-react-parser';
import Slider from "react-slick";
import ServiceDetail from "./bper-service-detail";

export default function AvailableServices({ services, translations }) {
    // const [isCarousel, setIsCarousel] = useState(false);
    const [showPopup, setShowPopup] = useState(undefined);
    /*
        useEffect(() => {
            if (window.innnerWidth > 1000) {
                setIsCarousel(services && services.length > 5);
            } else {
                if (window.innnerWidth > 767) {
                    setIsCarousel(services && services.length > 4);
                } else {
                    setIsCarousel(services && services.length > 2);
                }
            }
        }, [window.innnerWidth]);*/


    const isCarousel = services && (window.innnerWidth > 1000 ? services.length > 5 : window.innnerWidth > 767 ? services.length > 4 : services.length > 2);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    infinite: true,
                    centerMode: true,
                    slidesToShow: 1,
                }
            }
        ]
    }

    const currentService = showPopup ? services.filter(el => parseInt(el.serviceId) === parseInt(showPopup)) : undefined;
    
    debugger
    console.log("currentService:", currentService);
    
    return (
        <>
            {services && services.length > 0 &&
                <div className={"available-services n-" + services.length + " is-carousel-" + isCarousel}>
                    {
                        currentService &&
                        <div className="popup-filiali">
                            <div className="popup-filiali-wrapper">
                                <div class="bper-wrapper">
                                    <a className="close" onClick={() => setShowPopup(undefined)} style={{opacity:1}}>
                                        <span>chiudi</span>
                                    </a>
                                    <h2>{currentService[0].title}</h2>
                                    <div className="html">
                                        {parse(currentService[0].popup)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="bper-wrapper ">
                        <h3>
                            {translations.serviceAvailableInSubsidiary}
                        </h3>
                        {
                            isCarousel ?
                                <Slider {...settings}>
                                    {services.map((el, index) =>
                                        <ServiceDetail key={index} item={el} setShowPopup={setShowPopup} />
                                    )}
                                </Slider>
                                :
                                <div className="all-services">
                                    {services.map((el, index) =>
                                        <ServiceDetail key={index} item={el} setShowPopup={setShowPopup} />
                                    )}
                                </div>
                        }
                    </div>
                </div>
            }
        </>
    );
}